import React from 'react';
import { Text, Pressable } from 'react-native';
import { useTheme } from '@rneui/themed';
import { differenceInMinutes, format } from 'date-fns';
import PropTypes from 'prop-types';
import * as Utils from './utils';

const Event = props => {
    const { theme } = useTheme();
    const event = props?.event;
    const onEventPress = props?.onEventPress;
    const eventCellStyle = props?.eventCellStyle;
    const showTime = props?.showTime;
    const eventCount = props?.eventCount || 1;
    const eventOrder = props?.eventOrder || 0;

    const renderEvent = () => {
        if (differenceInMinutes(event.end, event.start) < 32 && showTime) {
            return (
                <>
                    <Text numberOfLines={1} style={theme?.appComponents?.umbraco?.EventCalendar?.CommonStyles.eventTitle}>
                        {event.title},{' '}
                    </Text>
                    <Text style={theme?.appComponents?.umbraco?.EventCalendar?.Event.eventTime}>{format(event.start, 'hh:mm')}</Text>
                </>
            );
        } else {
            return (
                <>
                    <Text style={theme?.appComponents?.umbraco?.EventCalendar?.CommonStyles.eventTitle}>{event.title}</Text>
                    {showTime && (
                        <Text style={theme?.appComponents?.umbraco?.EventCalendar?.Event.eventTime}>
                            {Utils.formatStartEnd(event)}
                            {event.children}
                        </Text>
                    )}
                </>
            );
        }
    };

    return (
        <Pressable
            delayPressIn={20}
            disabled={!onEventPress}
            key={event.id}
            onPress={() => onEventPress && onEventPress(event)}
            style={[
                theme?.appComponents?.umbraco?.EventCalendar?.CommonStyles.eventCell,
                Utils.getEventCellPositionStyle(event),
                Utils.getStyleForOverlappingEvent(eventCount, eventOrder),
                eventCellStyle
            ]}
        >
            {renderEvent()}
        </Pressable>
    );
};

Event.propTypes = {
    event: PropTypes.shape({
        end: PropTypes.instanceOf(Date).isRequired,
        id: PropTypes.string.isRequired,
        start: PropTypes.instanceOf(Date).isRequired,
        title: PropTypes.string.isRequired
    }).isRequired,
    eventCellStyle: PropTypes.object,
    eventCount: PropTypes.number,
    eventOrder: PropTypes.number,
    onEventPress: PropTypes.func,
    showTime: PropTypes.bool
};

export default React.memo(Event);
